import React, { Component } from "react";
import { Redirect, Link } from 'react-router-dom';
import ReactFullpage from '@fullpage/react-fullpage';
import styles from '../assets/scss/modules/kampany.module.scss';
import twitter from "../assets/media/images/Twitter.png";
import tiktok from "../assets/media/images/Tiktok.png";
import instagram from "../assets/media/images/Instagram.png";
import facebook from "../assets/media/images/Facebook.png";
import jogasz from "../assets/media/images/jogasz.png";
import kepviselo from "../assets/media/images/kepviselo.png";
import csalad from "../assets/media/images/csalad.png";
import asset1 from "../assets/media/images/asset1.png";
import asset2 from "../assets/media/images/asset2.png";
import asset3 from "../assets/media/images/asset3.png";
import asset4 from "../assets/media/images/asset4.png";
import asset5 from "../assets/media/images/Titles/lakhatasLakasfenntartas.png";
import asset6 from "../assets/media/images/asset6.png";
import back_btn from "../assets/media/newicons/back.png";
import back_btn_black from "../assets/media/newicons/back-black.png";
import forward_btn_black from "../assets/media/newicons/nextBlue.png";
import forward_btn from "../assets/media/newicons/forward.png";
import erikfoto from "../assets/media/images/Erik-foto.png";
import bild from "../assets/media/images/ProgramImages/LakhatasLakasfenntartas.jpg";
import konczer_facebook from "../assets/media/images/konczer-facebook.png";
import gradiensProgram from "../assets/media/images/gradiensProgram.png";
import Footer from "../components/Footer/Footer";
import FooterResponziv from "../components/Footer/FooterResponziv";
import BackComponent from "../components/Kiegeszitok/BackComponent";
import BackComponentRespo from "../components/Kiegeszitok/BackComponentRespo";
import NavbarComponent from "../NavbarComponent";
import { Scrollbar } from "react-scrollbars-custom";



import{
	MDBContainer,
  MDBScrollbar,
	MDBRow,
	MDBCol,
	MDBCard,
	MDBCardHeader,
	MDBCardBody,
  MDBBtn,
} from 'mdbreact';

class LakhatasLakasfenntartas extends Component {

	constructor(props) {
    super(props);
    this.state = {navbarPaddingTop: true,
									};
  };

	componentDidMount() {
		document.addEventListener("scroll", this.scrollEventListener);
	}

	componentWillUnmount() {
	}

	scrollEventListener = (event) => {
		const navPadding = window.scrollY < 100 ? true : false;
		this.setState({ navbarPaddingTop: navPadding});
	}


  render() {
		const anchors = ["program1", "program2", "program3"];
		let bodywrapperHeight = parseInt(window.outerWidth*0.8 + 100);
		let bodywrapperHeightText = bodywrapperHeight + "px";
    return (
			<>
			<MDBContainer fluid className="fluid-container">
				<div className="d-none d-lg-block">
					<div className={styles.bodywrapper7}>
						<BackComponent text={"KornyezetunkMegovasa"} text2={"Környezetünk megóvása"} program={"program4"}/>
						<img className="bild" src={bild}></img>
						<MDBContainer fluid className="program-container-programok">
							<Scrollbar
												id="scrollbar"
												style={{ width: "100%", height: "76vh", marginTop: "-5vh"}}
												maximalThumbYSize = {50}
												noScrollX = {true}
							>
								<MDBContainer fluid className="section" id="program">
									<div className={styles.bodywrapper3}>
										<MDBRow  center className="program-text-row">
										</MDBRow>
										<MDBRow  center className="program-text-row">
										<p className="jelenleg-is-ont-kepv">Ember embernek nem lehet farkasa! - lakhatás, lakásfenntartás</p>
										<p className="a-megyei-kozgyulesbe">Az elmúlt tíz évben a lakóingatlanárak megduplázódtak,
										a lakásbérleti díjak nagyjából másfélszeresre nőttek, lakhatási válság alakult ki Magyarországon.
										Ez magába foglalja az első lakás megszerzésének ellehetetlenülését, de a megszerzett vagy meglévő lakás fenntartásának problémáit is.
										Ennek ellenére az elmúlt évtized lakáspolitikája csak a tehetős kevesek ingatlanszerzését támogatta.</p>
										<p className="a-megyei-kozgyulesbe">Egyre nagyobb a túljelentkezés a megürülő önkormányzati bérlakásokra.
										Tatabányán 65 ezer lakosra 2 ezer, Tatán 23 ezer lakosra 280 önkormányzati bérlakás jut.</p>
										</MDBRow>
										<MDBRow  center className="program-text-row-end">
										<p className="a-megyei-kozgyulesbe">Csak Tatabányán mintegy 1000 új lakás felépítésére lenne szükség.
										Mindezek miatt települési bérlakás programot indítunk és központi költségvetési, valamint
										Európai Uniós fejlesztési források segítségével növeljük az önkormányzati bérlakás-állományt!
										A Tatabányai Bérlakás Program keretében ifjúsági garzon házakat hozunk létre,
										amelybe meghatározott ideig fiatal párok költözhetnek be, hogy előkészítsék a saját otthon megteremtését! </p>
										<p className="a-megyei-kozgyulesbe">A külterületeken (Baromállás Dűlő, Szigeti Dűlő,
											Barackos, Körtés, a Szénszállító út melletti kisebb „bokrok”), jellemzően szerény anyagi lehetőséggel rendelkezők élnek.
											E helyeken sokszor nincs megfelelő út, közvilágítás, hulladékszállítás. A téli fűtés is gyakran csupán a környezet
											pusztításával, fák kivágásával, levegő szennyezésével biztosítható. Nem ritka a komfort nélküli,
											egészségügyi veszélyt is jelentő telepek megléte (Mésztelep, 6-os telep egy része), mivel nincs alternatív lakhatási lehetőség. </p>
											<p className="a-megyei-kozgyulesbe">A Jogod van élni, jogod van lakni programban egyszerre segítünk a nehéz
											lakhatási helyzetben lévőkön és óvjuk a környezetkárosítástól a települést és számoljuk fel a szegregátumokat!</p>
											<p className="a-megyei-kozgyulesbe">Az életkor emelkedésével jelentősen nő az igény a bentlakásos gondozás iránt.
											A Tatabányai Járási Egyesített Szociális Intézményében közel 1 éves várólista keletkezett.
											Tatabányán és Tatán az önkormányzati fenntartású intézmények nagyjából 450 férőhellyel rendelkeznek.
											Az utóbbi időben (mivel a kórházak már nem tudnak nagyobb létszámnak ellátást biztosítani) tömegesen jelent meg a néhány hetes ellátási igény.
											Rendszeresen tapasztalható, hogy a magánvállalkozások térítési díjainak fedezetét a család nem tudja megteremteni.
											Bővíteni kell az állami és önkormányzati szociális ellátó intézmények kapacitását, növelni a jól megfizetett szakemberek számát az idősellátásban.</p>
											<p className="a-megyei-kozgyulesbe">Tatabányán mintegy 23000, Tatán közel 2200 távfűtött lakás van.
											Ezek egyedi fogyasztásmérése bár hasznos, de nem oldja meg az energiapazarlás problémáját,
											amelyet először épületenként kell csökkenteni, az itt élőknek ez jelentené a legnagyobb segítséget.
											Miután a beruházás nagysága miatt sokan ezt egyedül nem tudnák finanszírozni, ezért az újraindított
											Panelprogram keretében felújítjuk az iparosított technológiával épült házakat!
											Miután Tatabányán a napi csőtörésekből látható, hogy az ivóvíz-hálózat sok helyen elavult,
											ezért ivóvíz- és csatorna-rekonstrukcióval tesszük élhetőbbé a várost!</p>
											<p className="a-megyei-kozgyulesbe">A már megszerzett lakás elvesztésének sokak veszélyeztetettjei.
											A megugró albérleti díjak, a szükségszerű felújítások jövedelmi okokból történő elmaradása, a
											túlfűtött építőanyag-piacon tapasztalható árak már rövidtávon is előidézhetik, hogy a lakhatás ellehetetlenül.
											</p>
											<p className="a-megyei-kozgyulesbe">Újra bevezetjük az önkormányzatok hatáskörébe utalva a lakhatási támogatást, hogy az átmeneti pénzügyi
											zavarok ne vezessenek az otthonok elvesztéséhez!</p>
											<p className="a-megyei-kozgyulesbe">A hajléktalanság településeinken sem nem büntetőjogi, hanem szociális és egészségügyi kezelést igényel.
											Ma a mulasztó állam helyett – Tatabányán és Tatán is jórészt lakossági adományokból – önkormányzati,
											civil és egyházi szereplők igyekeznek helytállni A méltó élet érdekében források biztosításával emelni
											fogjuk a befogadóhelyek kapacitását és emelni az ellátási színvonalat!</p>
										</MDBRow>

									</div>
							</MDBContainer>

						</Scrollbar>
					</MDBContainer>

					<div className="fixed-bottom d-none d-lg-block">
					<div className="gradient"/>
						<Footer/>
					</div>
				</div>
				</div>
			</MDBContainer>

			<div className="d-block d-lg-none">
				<MDBContainer fluid className="fluid-container">
					<div className={styles.bodywrapper4}>
						<BackComponentRespo navbarPaddingTop={this.state.navbarPaddingTop} text={"KornyezetunkMegovasa"} program={"program4"}/>
						<img className="bild2" src={bild}></img>
					</div>
					<div className={styles.bodywrapper3}>
						<img className="asset5-respo" src={asset5}></img>
						<MDBRow  center className="program-text-row m-0 px-3">
						<p className="jelenleg-is-ont-kepv">Ember embernek nem lehet farkasa! - lakhatás, lakásfenntartás</p>
						<p className="a-megyei-kozgyulesbe">Az elmúlt tíz évben a lakóingatlanárak megduplázódtak,
						a lakásbérleti díjak nagyjából másfélszeresre nőttek, lakhatási válság alakult ki Magyarországon.
						Ez magába foglalja az első lakás megszerzésének ellehetetlenülését, de a megszerzett vagy meglévő lakás fenntartásának problémáit is.
						Ennek ellenére az elmúlt évtized lakáspolitikája csak a tehetős kevesek ingatlanszerzését támogatta.</p>
						<p className="a-megyei-kozgyulesbe">Egyre nagyobb a túljelentkezés a megürülő önkormányzati bérlakásokra.
						Tatabányán 65 ezer lakosra 2 ezer, Tatán 23 ezer lakosra 280 önkormányzati bérlakás jut.</p>
						</MDBRow>
						<MDBRow  center className="program-text-row-end m-0 px-3">
						<p className="a-megyei-kozgyulesbe">Csak Tatabányán mintegy 1000 új lakás felépítésére lenne szükség.
						Mindezek miatt települési bérlakás programot indítunk és központi költségvetési, valamint
						Európai Uniós fejlesztési források segítségével növeljük az önkormányzati bérlakás-állományt!
						A Tatabányai Bérlakás Program keretében ifjúsági garzon házakat hozunk létre,
						amelybe meghatározott ideig fiatal párok költözhetnek be, hogy előkészítsék a saját otthon megteremtését! </p>
						<p className="a-megyei-kozgyulesbe">A külterületeken (Baromállás Dűlő, Szigeti Dűlő,
							Barackos, Körtés, a Szénszállító út melletti kisebb „bokrok”), jellemzően szerény anyagi lehetőséggel rendelkezők élnek.
							E helyeken sokszor nincs megfelelő út, közvilágítás, hulladékszállítás. A téli fűtés is gyakran csupán a környezet
							pusztításával, fák kivágásával, levegő szennyezésével biztosítható. Nem ritka a komfort nélküli,
							egészségügyi veszélyt is jelentő telepek megléte (Mésztelep, 6-os telep egy része), mivel nincs alternatív lakhatási lehetőség. </p>
							<p className="a-megyei-kozgyulesbe">A Jogod van élni, jogod van lakni programban egyszerre segítünk a nehéz
							lakhatási helyzetben lévőkön és óvjuk a környezetkárosítástól a települést és számoljuk fel a szegregátumokat!</p>
							<p className="a-megyei-kozgyulesbe">Az életkor emelkedésével jelentősen nő az igény a bentlakásos gondozás iránt.
							A Tatabányai Járási Egyesített Szociális Intézményében közel 1 éves várólista keletkezett.
							Tatabányán és Tatán az önkormányzati fenntartású intézmények nagyjából 450 férőhellyel rendelkeznek.
							Az utóbbi időben (mivel a kórházak már nem tudnak nagyobb létszámnak ellátást biztosítani) tömegesen jelent meg a néhány hetes ellátási igény.
							Rendszeresen tapasztalható, hogy a magánvállalkozások térítési díjainak fedezetét a család nem tudja megteremteni.
							Bővíteni kell az állami és önkormányzati szociális ellátó intézmények kapacitását, növelni a jól megfizetett szakemberek számát az idősellátásban.</p>
							<p className="a-megyei-kozgyulesbe">Tatabányán mintegy 23000, Tatán közel 2200 távfűtött lakás van.
							Ezek egyedi fogyasztásmérése bár hasznos, de nem oldja meg az energiapazarlás problémáját,
							amelyet először épületenként kell csökkenteni, az itt élőknek ez jelentené a legnagyobb segítséget.
							Miután a beruházás nagysága miatt sokan ezt egyedül nem tudnák finanszírozni, ezért az újraindított
							Panelprogram keretében felújítjuk az iparosított technológiával épült házakat!
							Miután Tatabányán a napi csőtörésekből látható, hogy az ivóvíz-hálózat sok helyen elavult,
							ezért ivóvíz- és csatorna-rekonstrukcióval tesszük élhetőbbé a várost!</p>
							<p className="a-megyei-kozgyulesbe">A már megszerzett lakás elvesztésének sokak veszélyeztetettjei.
							A megugró albérleti díjak, a szükségszerű felújítások jövedelmi okokból történő elmaradása, a
							túlfűtött építőanyag-piacon tapasztalható árak már rövidtávon is előidézhetik, hogy a lakhatás ellehetetlenül.
							</p>
							<p className="a-megyei-kozgyulesbe">Újra bevezetjük az önkormányzatok hatáskörébe utalva a lakhatási támogatást, hogy az átmeneti pénzügyi
							zavarok ne vezessenek az otthonok elvesztéséhez!</p>
							<p className="a-megyei-kozgyulesbe">A hajléktalanság településeinken sem nem büntetőjogi, hanem szociális és egészségügyi kezelést igényel.
							Ma a mulasztó állam helyett – Tatabányán és Tatán is jórészt lakossági adományokból – önkormányzati,
							civil és egyházi szereplők igyekeznek helytállni A méltó élet érdekében források biztosításával emelni
							fogjuk a befogadóhelyek kapacitását és emelni az ellátási színvonalat!</p>
						</MDBRow>
					</div>
				</MDBContainer>
				<MDBContainer fluid className="fluid-container">
					<div className={styles.bodywrapper5}>
						<FooterResponziv/>
					</div>
				</MDBContainer>
			</div>
      </>
    );
  }
}
export default  LakhatasLakasfenntartas;
